import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js"; // Reused component
import Features from "../../../../Components/Features/ThreeColumnPages"; // Reused component
import {
  FaPaintBrush,
  FaUsers,
  FaHandshake,
  FaAward,
  FaMapMarkerAlt,
  FaMobileAlt,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

// Mobile App UI/UX Design in Bur Dubai Page Component
export const MobileAppUIUXDesignInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Mobile App UI/UX Design in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Transform Your Mobile Presence</Subheading>}
        heading={
          <Heading>
            Elevate Your Brand with{" "}
            <span tw="text-primary-500">
              The Best Mobile App UI/UX Design in Bur Dubai
            </span>
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in delivering professional mobile
            app UI/UX design services tailored for businesses in **Bur Dubai**,
            Dubai. Our team combines creativity, strategy, and local insights to
            help you engage your audience, grow your brand, and achieve
            measurable results through impactful mobile experiences.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1573867639040-6dd25fa5f597?ixlib=rb-4.0.3&auto=format&fit=crop&q=80", // Mobile app UI design
          "https://images.unsplash.com/photo-1559028006-448665bd7c7f?ixlib=rb-4.0.3&auto=format&fit=crop&q=80", // Designer working on mobile app
          "https://images.unsplash.com/photo-1612831455359-970e23a1e4e9?ixlib=rb-4.0.3&auto=format&fit=crop&q=80", // Mobile app prototyping
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Get Started Today"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Your Trusted Partner for Mobile App UI/UX Design in Bur Dubai"
        description="We combine creativity, strategy, and innovation to deliver unmatched value."
        cards={[
          {
            icon: <FaPaintBrush color="#ff5464" size={40} />,
            title: "Creative Designs",
            description:
              "Craft visually stunning and intuitive interfaces that captivate your audience.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile-First Approach",
            description:
              "Deliver seamless experiences optimized for all mobile devices.",
          },
          {
            icon: <FaMapMarkerAlt color="#ff5464" size={40} />,
            title: "Localized Expertise",
            description:
              "Understand Bur Dubai's unique market trends and diverse demographics.",
          },
          {
            icon: <FaUsers color="#ff5464" size={40} />,
            title: "User-Centric Approach",
            description:
              "Design seamless experiences that prioritize usability and engagement.",
          },
          {
            icon: <FaHandshake color="#ff5464" size={40} />,
            title: "Client-Centric Collaboration",
            description:
              "Work closely with you to ensure alignment with your vision and goals.",
          },
          {
            icon: <FaAward color="#ff5464" size={40} />,
            title: "Proven Track Record",
            description:
              "Delivering exceptional results for Bur Dubai clients since [Year].",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Streamlined Process for Mobile App UI/UX Design in Bur Dubai"
        description={
          <Description>
            Our Bur Dubai-focused process ensures quality, efficiency, and
            measurable results:
            <ul tw="mt-4 list-disc pl-6">
              <li>
                Discovery & Research: Understand your business, audience, and
                goals.
              </li>
              <li>
                User Analysis: Identify your target demographic and their
                preferences.
              </li>
              <li>
                Wireframing & Prototyping: Create interactive prototypes for
                testing and feedback.
              </li>
              <li>
                Design Execution: Craft visually stunning and intuitive designs
                tailored for your audience.
              </li>
              <li>
                Development Integration: Collaborate with developers to bring
                your designs to life.
              </li>
              <li>
                Optimization & Feedback: Continuously refine designs based on
                user feedback and performance metrics.
              </li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1602536013664-d5b15e606d9f?ixlib=rb-4.0.3&auto=format&fit=crop&q=80", // Mobile UI components
          "https://images.unsplash.com/photo-1588702547919-26089e690ecc?ixlib=rb-4.0.3&auto=format&fit=crop&q=80", // Team designing mobile experience
          "https://images.unsplash.com/photo-1581287053822-fd7bf4f4bfec?ixlib=rb-4.0.3&auto=format&fit=crop&q=80", // User testing mobile app
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Results That Speak for Themselves"
        description="Here’s how our mobile app UI/UX design services have empowered businesses in Bur Dubai."
        cards={[
          {
            icon: <FaAward color="#ff5464" size={40} />,
            title: "Improved User Engagement",
            description:
              "Helped a food delivery startup in Bur Dubai increase user retention by 150% through intuitive design.",
          },
          {
            icon: <FaHandshake color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description:
              "98% client retention rate through consistent excellence and measurable results.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile Optimization",
            description:
              "Achieved a 200% increase in conversions for a local retail app using streamlined UI/UX.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={
          <Subheading>Ready to Elevate Your Mobile Presence?</Subheading>
        }
        heading="Let’s Build Exceptional Experiences Together in Bur Dubai"
        description={
          <Description>
            Partner with Bur Dubai’s leading mobile app UI/UX experts to unlock
            your business’s full potential. Whether you’re launching a new app
            or revamping an existing one, we’re here to help.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1581287053822-fd7bf4f4bfec?ixlib=rb-4.0.3&auto=format&fit=crop&q=80", // Team collaboration on mobile designs
          "https://images.unsplash.com/photo-1580414057403-c5f451f30e1c?ixlib=rb-4.0.3&auto=format&fit=crop&q=80", // Dubai skyline for local context
          "https://images.unsplash.com/photo-1583608205776-bfd35f0d9f83?ixlib=rb-4.0.3&auto=format&fit=crop&q=80", // Person using mobile application
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Today"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
